import { useCallback } from 'react';

const AUTH_OPTIONS = [
  { value: 'plain', label: 'Plain' },
  { value: 'login', label: 'Login' },
  { value: 'cram_md5', label: 'CRAM-MD5' },
];

const ENCRYPTION_OPTIONS = [
  { value: 'none', label: 'Nenhuma' },
  { value: 'starttls', label: 'STARTTLS' },
  { value: 'ssl_tls', label: 'SSL/TLS' },
];

export interface SmtpFormValues {
  address: string;
  port: string;
  userName: string;
  password: string;
  authentication: string;
  encryption: string;
  senderEmail: string;
  senderName: string;
}

export function useSmtpValidation(smtpConfiguration: { id: string } | null) {
  const validate = useCallback((values: SmtpFormValues): Record<string, string> => {
    const errors: Record<string, string> = {};

    if (!values.address.trim()) {
      errors.address = 'Endereço do servidor é obrigatório';
    }

    if (!values.port.trim()) {
      errors.port = 'Porta é obrigatória';
    } else {
      const portNum = parseInt(values.port, 10);
      if (isNaN(portNum) || portNum <= 0 || portNum > 65535) {
        errors.port = 'Porta deve ser um número entre 1 e 65535';
      }
    }

    if (!values.userName.trim()) {
      errors.user_name = 'Nome de usuário é obrigatório';
    }

    if (!smtpConfiguration && !values.password.trim()) {
      errors.password = 'Senha é obrigatória';
    }

    if (!AUTH_OPTIONS.some((opt) => opt.value === values.authentication)) {
      errors.authentication = 'Método de autenticação inválido';
    }

    if (!ENCRYPTION_OPTIONS.some((opt) => opt.value === values.encryption)) {
      errors.encryption = 'Método de criptografia inválido';
    }

    if (!values.senderEmail.trim()) {
      errors.sender_email = 'E-mail do remetente é obrigatório';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.senderEmail)) {
      errors.sender_email = 'E-mail do remetente inválido';
    }

    return errors;
  }, [smtpConfiguration]);

  return { validate };
}
